import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=b6cc8ed6&scoped=true&"
import script from "./alert.vue?vue&type=script&lang=js&"
export * from "./alert.vue?vue&type=script&lang=js&"
import style0 from "./alert.vue?vue&type=style&index=0&id=b6cc8ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cc8ed6",
  null
  
)

export default component.exports